import React from 'react'
import styles from './styles.module.scss'
import { ReactComponent as DiscountTagSvg } from '@svgs/keyline/discount-tag.svg'

type DiscountCodeProps = {
  code: string
  variant?: 'default' | 'small'
}

const DiscountCode = ({ code, variant = 'default' }: DiscountCodeProps) => (
  <span className={`${styles.DiscountCode__code} ${styles[variant]}`}>
    <DiscountTagSvg
      width="19"
      className={styles.DiscountCode__icon}
    ></DiscountTagSvg>
    {code}
  </span>
)

export default DiscountCode
